import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Link,
  Typography,
  Tooltip,
  Stack,
  Button,
  IconButton,
  CircularProgress,
  Menu,
  MenuItem,
} from "@mui/material";
import { useParams, Link as RouterLink, useLocation } from "react-router-dom";

import DownloadIcon from "@mui/icons-material/Download";
import { useNavigate } from "react-router-dom";
import { s3baseUrl, baseUri } from "src/config/config";
import { saveAs } from "file-saver";
import { useSnackbar } from "notistack";
import { htmlDecode } from "src/utils/convertHtml";
import {
  csvImage,
  docImage,
  pdfImage,
  wordImage,
  audioImage,
  xlsxImage,
  otherImage,
} from "src/assets";
import { makeStyles } from "@mui/styles";
import RecordNotFoundAssets from "./RecordNotFoundAssets";
import { digitalAssetsListingApi } from "src/DAL/DigitalAssetsApi/Assetsapi";
const ITEM_HEIGHT = 48;
const imageLink = {
  docx: wordImage,
  mp3: audioImage,
  pdf: pdfImage,
  csv: csvImage,
  doc: docImage,
  xlsx: xlsxImage,
  xls: xlsxImage,
  other: otherImage,
};
const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));
export const DigitalAssets = () => {
  const navigate = useNavigate();
  const params = useParams();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);
  const [documentList, setDocumentList] = useState([]);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [deleteDoc, setDeleteDoc] = React.useState("");
  const handleDownload = async (path) => {
  console.log(path,'path')
    setIsLoading(true);
    const file_path = `${s3baseUrl}${path}`;
    fetch(file_path)
      .then(async (res) => {
        if (res.status === 200) {
          let blob = await res.blob();
          saveAs(blob, path);
          setIsLoading(false);
        } else {
          enqueueSnackbar(res.statusText, { variant: "error" });
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  // `/digital-assets/edit-asset-document/:slug/${params.id}`
  const handleAgreeDelete = (value) => {
    
    setDeleteDoc(value._id);
    setOpenDelete(true);
  }; 
  const getDocument = async () => {
    setIsWaiting(true);
    let result = await digitalAssetsListingApi();
    if (result.code == 200) {
      setIsWaiting(false);
      setDocumentList(result.assets);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsWaiting(false);
    }
  };
  const getResourceImage = (doc) => {
    if (doc.assets_thumbnail) {
      return s3baseUrl + doc.assets_thumbnail
      ;
    } else if (doc.file_type
      == "image") {
      return s3baseUrl + doc?.assets_images_url?.thumbnail_1;
    } else {
      const ext = doc.assets_file_url?.split(".").pop();
      if (imageLink[ext]) {
        return imageLink[ext];
      } else {
        return imageLink.other;
      }
    }
  };
  const handleGetValue = () => {
    //console.log("ok clicked");
  };
  useEffect(() => {
    getDocument();
  }, []);
  if (isWaiting) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12">
          </div>
          <div className="col-12">
            <h1>Digital Assets</h1>
          </div>
          <div className="col-lg-12 col-sm-12 text-end"></div>
          {documentList.length < 1 ? (
            <RecordNotFoundAssets title="Document" />
          ) : (
            documentList?.map((value, i) => {
              return (
                <div className="col-sm-12 col-md-6 col-lg-6 mb-4" key={i}>
                  <div className="card mt-4 pods-cards-shadow cursor h-100 ">
                    <div className="row">
                      <div className="col-md-3">
                        <img
                          src={getResourceImage(value)}
                          className="pt-3 ps-3"
                          height="80px"
                          alt="Programme"
                        />
                      </div>
                      <div className="col-md-9 ps-0">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-10">
                              <h3
                                className="h2-heading"
                                // onClick={() => handleNavigateDetail(value)}
                              >
                                {htmlDecode(value.title)}
                              </h3>
                            </div>

                            <div
                              className="col-2 menu-option text-end"
                              onClick={handleGetValue}
                            >
                              {/* <CustomPopover menu={MENU_OPTIONS} data={value} /> */}
                            </div>
                          </div>
                          <p
                            className="programme-card-desc mb-3">
                            {htmlDecode(value.short_description)}
                          </p>
                          <div className="col-12 text-end download-icon">
                            <Tooltip title="Download">
                              <DownloadIcon
                                onClick={() => {
                                  let path = " ";
                                  if (value.file_type === "image") {
                                    path =
                                      value.assets_images_url.thumbnail_1;
                                  } else {
                                    path = value.assets_file_url;
                                  }
                                  handleDownload(path);
                                }}
                                className="icon-style"
                              />
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </>
  );
};
